export class ParameterModel{
    Id: number;
    Codigo: String;
    Valor: String;

    ParameterModel(){
        this.Id =0;
        this.Codigo ="";
        this.Valor ="";
    }
}